import React, { useState } from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import { groupBySize } from "../../utils/utils";
import KTabs from "../ui/tabs/KTabs";
import KTabPanel from "../ui/tabs/KTabPanel";
import MetricsTable from "./MetricsTable";

const useStyle = makeStyles((theme) => ({
  headingTitle: {
    color: theme.palette.grey[500],
  },
  table: {
    minWidth: 650,
  },
}));

const Event = ({ event, handleClick, index, open }) => {
  const classes = useStyle();

  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    { label: "Position", value: 0 },
    { label: "IO Values", value: 1 },
    { label: "IO Parsed", value: 2 },
    { label: "Calculated Input", value: 3 },
  ];

  const position_data = event
    ? groupBySize(
        Object.entries(event.position).map((el) => ({
          label: el[0],
          value: el[1],
        })),
        10,
      )
    : [];
  const io_values = event
    ? groupBySize(
        Object.entries(event.io_values).map((el) => ({
          label: el[0],
          value: el[1],
        })),
        6,
      )
    : [];
  const io_parsed = event
    ? groupBySize(
        Object.entries(event.io_parsed).map((el) => ({
          label: el[0],
          value: el[1],
        })),
        6,
      )
    : [];
  const calculated_inputs = event
    ? groupBySize(
        Object.entries(event.calculated_inputs).map((el) => ({
          label: el[0],
          value: el[1],
        })),
        10,
      )
    : [];

  const handleChange = (e, expanded) => handleClick(index, expanded);

  return (
    <>
      {event === undefined ? null : (
        <Accordion
          onChange={(e, expanded) => handleChange(e, expanded)}
          expanded={open}
        >
          <AccordionSummary aria-controls="panel1a-content" id="panel1a-header">
            <div style={{ marginRight: "24px" }}>
              <Typography variant="caption" className={classes.headingTitle}>
                Datetime (UTC)
              </Typography>
              <Typography variant="body2">
                {moment.utc(event.datetime).format("DD.MM.YYYY, HH:mm:ss")}
              </Typography>
            </div>
            <div style={{ marginRight: "24px" }}>
              <Typography variant="caption" className={classes.headingTitle}>
                Ignition
              </Typography>
              <Typography variant="body2">
                {event.calculated_inputs?.ignition ? "On" : "Off"}
              </Typography>
            </div>
            <div style={{ marginRight: "24px" }}>
              <Typography variant="caption" className={classes.headingTitle}>
                Speed
              </Typography>
              <Typography variant="body2">{event.position.speed}</Typography>
            </div>
            <div style={{ marginRight: "24px" }}>
              <Typography variant="caption" className={classes.headingTitle}>
                Vehicle UUID
              </Typography>
              <Typography variant="body2">
                <Link
                  to={`/config/vehicles/${event.vehicle_uuid}`}
                  style={{ color: "#0066b3", textDecoration: "none" }}
                >
                  {event.vehicle_uuid}
                </Link>
              </Typography>
            </div>
            <div style={{ marginRight: "24px" }}>
              <Typography variant="caption" className={classes.headingTitle}>
                Customer
              </Typography>
              <Typography variant="body2">{event.customer}</Typography>
            </div>
            <div style={{ marginRight: "24px" }}>
              <Typography variant="caption" className={classes.headingTitle}>
                Satellites
              </Typography>
              <Typography variant="body2">
                {event.position.satellites_count}
              </Typography>
            </div>
            <div style={{ marginRight: "24px" }}>
              <Typography variant="caption" className={classes.headingTitle}>
                Imported
              </Typography>
              <Typography variant="body2">
                {moment.utc(event.imported).format("DD.MM.YYYY, HH:mm:ss")}
              </Typography>
            </div>
          </AccordionSummary>
          <AccordionDetails style={{ height: "320px", overflow: "auto" }}>
            <div>
              <KTabs
                activeTab={activeTab}
                handleChange={(e, v) => setActiveTab(v)}
                tabs={tabs}
              />
              <div>
                <KTabPanel value={activeTab} index={0}>
                  <MetricsTable
                    data={position_data}
                    valueAccess={(el) => el.value}
                  />
                </KTabPanel>
                <KTabPanel value={activeTab} index={1}>
                  <MetricsTable
                    data={io_values}
                    valueAccess={(el) => el.value}
                  />
                </KTabPanel>
                <KTabPanel value={activeTab} index={2}>
                  <MetricsTable
                    data={io_parsed}
                    valueAccess={(el) => el.value.value}
                    popperAccess={(el) => el.value}
                    withInfo={true}
                  />
                </KTabPanel>
                <KTabPanel value={activeTab} index={3}>
                  <MetricsTable
                    data={calculated_inputs}
                    valueAccess={(el) => el.value}
                    popperAccess={(el) => el.value}
                    withInfo={true}
                  />
                </KTabPanel>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
      )}
    </>
  );
};

export default Event;
